<template>
    <TwemojiPicker
            :emojiData="emojiDataAll"
            :emojiGroups="emojiGroups"
            :skinsSelection="false"
            :searchEmojisFeat="false"
            :pickerArrowEnabled="false"
            :pickerAutoflip="false"
            searchEmojiPlaceholder="Search here."
            searchEmojiNotFound="Emojis not found."
            isLoadingLabel="Loading..."
            picker-placement="bottom-start"
            :picker-width=290
            :picker-height=180
            @emojiUnicodeAdded="select"
    >
        <template v-slot:twemoji-picker-button>
            <div class="comment-emoji__image"></div>
        </template>
    </TwemojiPicker>
</template>

<script>
    import {TwemojiPicker} from '@kevinfaguiar/vue-twemoji-picker';
    import EmojiAllData from '@kevinfaguiar/vue-twemoji-picker/emoji-data/ru/emoji-all-groups.json';
    import EmojiGroups from '@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json';

    export default {
        name: "VueTwemojiPicker",
        components: {
            TwemojiPicker
        },
        computed: {
            emojiDataAll() {
                return EmojiAllData;
            },
            emojiGroups() {
                return EmojiGroups;
            }
        },
        methods: {
            select(emoji) {
                this.$emit('selected', emoji);
            },
        }
    }
</script>

<style scoped>

</style>
